import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { FlMi2GridComponent } from '../main-frontline/flmi2-grid.component';
import { CmpsFrontLineMi2Module } from '../main-frontline/frontline-mi2.module';
import { CmpsMi2MainModule } from '../main/main.module';
import { CmpsMi2TableModule } from '../table';

import { TranslationIdMap } from './main-fl.i18n';
import { FrontlineMI2Service } from './services/frontline-mi2.service';

@NgModule({
    declarations: [FlMi2GridComponent],
    exports: [FlMi2GridComponent],
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsChipModule,
        CmpsButtonModule,
        CmpsFilterModule,
        CmpsPortalModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMi2TableModule,
        CmpsFrontLineMi2Module,
        CmpsMi2MainModule,
    ],
    providers: [FrontlineMI2Service],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CmpsFLMi2MainModule {}
